enum UserManagementSubmenuConstants {
  GET_USER_MANAGEMENT_SUBMENU = '@UserManagementSubmenuContainer/GET_USER_MANAGEMENT_SUBMENU',
  GET_USER_MANAGEMENT_SUBMENU_REQUEST = '@UserManagementSubmenuContainer/GET_USER_MANAGEMENT_SUBMENU_REQUEST',
  GET_USER_MANAGEMENT_SUBMENU_REQUEST_SUCCESS = '@UserManagementSubmenuContainer/GET_USER_MANAGEMENT_SUBMENU_REQUEST_SUCCESS',
  GET_USER_MANAGEMENT_SUBMENU_REQUEST_ERROR = '@UserManagementSubmenuContainer/GET_USER_MANAGEMENT_SUBMENU_REQUEST_ERROR',
}

export default UserManagementSubmenuConstants;
